var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_panel"},[_c('div',{staticClass:"titys"},[_vm._v(_vm._s(parseInt(Math.random() * (50 - 20 + 1) + 20)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }